import { render, staticRenderFns } from "./CardsSentBySenderProfiles.vue?vue&type=template&id=1d539ffa"
import script from "./CardsSentBySenderProfiles.vue?vue&type=script&lang=js"
export * from "./CardsSentBySenderProfiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports